import { Options } from '@scoir/api'

import api from 'common/api'

import { StudentInfo } from './Context'

type UpdatePreferenceBody = {
  preferenceType: 'share_with_all_colleges' | 'ask_me_every_time'
  studentInfo: StudentInfo
}

export const updateStudentInterest = (interestInfo: UpdatePreferenceBody, eventData: Options) => {
  return api.post<UpdatePreferenceBody, null>(
    '/api/student/interest_sharing/update_preference',
    interestInfo,
    eventData,
  )
}

type SaveCollegeInterestBody = {
  scid: number
  studentInfo: StudentInfo
}
export const saveCollegeInterest = (interestInfo: SaveCollegeInterestBody, eventData: Options) => {
  return api.post<SaveCollegeInterestBody, null>('/api/student/interest_sharing/save_interest', interestInfo, eventData)
}
